export default __webpack_public_path__ + "static/media/okra.0c9ebfcb.svg";